import { SvgIcon, type SvgIconProps } from '@mui/material';

import { mergeSxProps } from 'common';

interface FlowTemplateCardPlaceholderIconProps extends SvgIconProps {
  title: string;
}

export function FlowTemplateCardPlaceholderIcon(props: FlowTemplateCardPlaceholderIconProps) {
  const { title, ...svgIconProps } = props;

  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      titleAccess={title}
      {...svgIconProps}
      sx={mergeSxProps(props.sx, {
        fill: 'none',
        fontSize: '24px',
      })}
    >
      <rect width="24" height="24" rx="4" fill="#E0E0E0" />
      <path
        d="M7.8 17.4H16.2C16.8628 17.4 17.4 16.8628 17.4 16.2V7.8C17.4 7.13726 16.8628 6.6 16.2 6.6H7.8C7.13726 6.6 6.6 7.13726 6.6 7.8V16.2C6.6 16.8628 7.13726 17.4 7.8 17.4ZM7.8 17.4L14.4 10.8L17.4 13.8M10.8 9.9C10.8 10.397 10.397 10.8 9.9 10.8C9.40295 10.8 9 10.397 9 9.9C9 9.40295 9.40295 9 9.9 9C10.397 9 10.8 9.40295 10.8 9.9Z"
        stroke="#9E9E9E"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
